import apiSlice from "./apiSlice";

const rolePackageSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({

        // Get All Role
        getAllRole: builder.query({
            query: (params) => ({
                url: `Roles`,
                params
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
            providesTags: ["RoleList"],
        }),

        // Add New Role
        addRole: builder.mutation({
            query: (role) => ({
                url: 'Roles',
                method: 'POST',
                body: role,
            }),
            invalidatesTags: ['RoleList'],
        }),

        // Update Role
        updateRole: builder.mutation({
            query: (role) => ({
                url: `Roles`,
                method: 'PUT',
                body: role,
            }),
            invalidatesTags: ['RoleList'],
        }),

        // Delete Role
        deleteRole: builder.mutation({
            query: (id) => ({
                url: `Roles/${id}`,
                method: 'DELETE',
            }),
            invalidatesTags: ['RoleList'],
        }),

        // Add New Role
        assignPermission: builder.mutation({
            query: (role) => ({
                url: 'RolePermission/assign-permissions',
                method: 'POST',
                body: role,
            }),
        }),
        getCheckRolePermission: builder.query({
            query: (roleId) => ({
                url: `RolePermission/get-permissions/${roleId}`
            }),
            providesTags: ["RoleList"],
        }),
    }),
});

export default rolePackageSlice;

export const {
    useGetAllRoleQuery, useAddRoleMutation, useUpdateRoleMutation, useDeleteRoleMutation, useAssignPermissionMutation,
    useLazyGetCheckRolePermissionQuery
} = rolePackageSlice;